import { Component, OnDestroy, OnInit } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { FormatConfigService } from '../../core/services/format-config.service';
import { SettingsConfigResponse } from '../../core/base-api';
import { NgStyle } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'cap-environment-marker',
  templateUrl: './environment-marker.component.html',
  styleUrls: ['./environment-marker.component.scss'],
  imports: [NgStyle, TranslatePipe]
})
export class EnvironmentMarkerComponent implements OnInit, OnDestroy {
  environmentName: string;
  environmentColor: string;

  private defaultColorEntwicklungsumgebung = '#779ECB';
  private defaultColorTestumgebung = '#8acb77';
  private subscription: Subscription = new Subscription();

  backgroundStyle;

  constructor(private appformatConfigService: FormatConfigService) {
    keysToTranslate<string>(['layouts.entwicklungsUmgebung', 'layouts.testUmgebung']);
  }

  ngOnInit() {
    this.subscription.add(
      this.appformatConfigService.settingsConfig$.subscribe((config) => {
        this.configUmgebung(config);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private configUmgebung(settingsConfig: SettingsConfigResponse) {
    if (!settingsConfig) {
      return;
    }
    const customColorEntwicklung = EnvironmentMarkerComponent.getHexValue(settingsConfig.colorUmgebung);
    switch (settingsConfig.nameUmgebung) {
      case 'Testumgebung':
        this.environmentName = 'layouts.testUmgebung';
        this.environmentColor = this.isValidHexColor(customColorEntwicklung) ? customColorEntwicklung : this.defaultColorTestumgebung;
        break;
      case 'Entwicklungsumgebung':
        this.environmentName = 'layouts.entwicklungsUmgebung';
        this.environmentColor = this.isValidHexColor(customColorEntwicklung)
          ? customColorEntwicklung
          : this.defaultColorEntwicklungsumgebung;
        break;
      default:
        this.environmentName = settingsConfig.nameUmgebung;
        this.environmentColor = this.isValidHexColor(customColorEntwicklung) ? customColorEntwicklung : null;
        break;
    }
    this.configBackgroundStyle();
  }

  private configBackgroundStyle() {
    this.backgroundStyle = {
      'background-color': this.environmentColor
    };
  }

  private static getHexValue(color: string) {
    if (color) {
      return color.startsWith('#') ? color : '#' + color;
    }
    return null;
  }

  isValidHexColor(color: string) {
    return color && /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);
  }
}
